<script setup lang="ts">
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import DashboardHeader from '@/components/header/DashboardHeader.vue'
import SidebarToggle from '@/components/sidebar/SidebarToggle.vue'
import LearnSidebar from '@/components/learn/LearnSidebar.vue'
import MobileBottomNav from '@/components/shared/MobileBottomNav.vue'

// The Learn module has no font/reciter/audio settings to show (nothing is
// being read here), so the header's settings-gear button is simply left
// unhandled rather than reusing SettingsSidebar with a fake Quran-reader
// state that wouldn't mean anything on this page.
</script>

<template>
  <div class="flex h-dvh max-h-dvh min-h-0 flex-col overflow-hidden bg-background text-foreground">
    <DashboardHeader />

    <SidebarProvider
      class="flex !min-h-0 flex-1 overflow-hidden"
      :default-open="true"
      :style="{ '--sidebar-width': '18rem' }"
    >
      <LearnSidebar />

      <SidebarInset class="flex !min-h-0 flex-1 flex-col overflow-hidden bg-background">
        <div
          tabindex="0"
          role="region"
          aria-label="Main content"
          class="flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-y-contain outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
        >
          <div
            class="sticky top-0 z-50 flex shrink-0 items-center justify-start border-b bg-background/90 px-2 py-1 backdrop-blur supports-[backdrop-filter]:bg-background/60 sm:px-4"
          >
            <SidebarToggle />
          </div>
          <div class="min-h-0 min-w-0 flex-1 pb-20 md:pb-0">
            <slot />
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>

    <MobileBottomNav />
  </div>
</template>
